import { Switch } from '@kula-ai/components';

import { useThemePreference } from './useThemePreference';

/** A single on/off switch for dark mode, for compact spots like menus. */
export const DarkModeSwitch = () => {
  const { resolvedTheme, setPreference } = useThemePreference();

  return (
    <Switch
      size="sm"
      aria-label="Dark mode"
      checked={resolvedTheme === 'dark'}
      onCheckedChange={(on) => setPreference(on ? 'dark' : 'light')}
      data-test-id="dark-mode-switch"
    />
  );
};
